export const INTERATIVE_COMMENT_LOCAL = "interactive-comments-frontedMentor";
